import React, { useEffect, useState } from "react";
import useUrl from "../../../hook/useUrl";
import { Link } from "@quintype/components";
import TimeStamp from "../../atoms/time-stamp";
import StarShowHide from "../../atoms/star-show-hide";
import { ShowMoreBtn } from "../../atoms/show-more-btn";
import "./chartbeat-stories.m.css";

const ChartbeatStories = () => {
  const [chartbeatStories, setChartbeatStories] = useState([]);
  const [loadMore, setLoadMore] = useState(5);
  const [_, currentUrlSlug] = useUrl();

  useEffect(() => {
    let apiUrl;
    const getApiUrl = (formattedDate) => {
      if (window !== "undefined") {
      const host = window.location.host;

      if (host === 'ilkkapohjalainen.fi') {
        apiUrl = `https://neoint-prod-imediat.fiareconsulting.com/api/chartbeat/fetch?startdate=${formattedDate}&enddate=${formattedDate}`;
      } else {
        apiUrl = `https://integration.imediat.fiareads.com/api/chartbeat/fetch?startdate=${formattedDate}&enddate=${formattedDate}`;
      }
    } else {
      apiUrl = `https://integration.imediat.fiareads.com/api/chartbeat/fetch?startdate=${formattedDate}&enddate=${formattedDate}`;
    }
      return apiUrl;
    };


    const fetchChartData = async () => {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, "0");
      const day = String(today.getDate()).padStart(2, "0");
      const formattedDate = `${year}${month}${day}`;
      const apiUrl = getApiUrl(formattedDate);
      try {
        const response = await fetch(apiUrl);
        const result = await response.json();
        const storyLists = (result.data && result.data) || [];
        setChartbeatStories(storyLists);
      } catch (error) {
        console.error("Error fetching the data", error);
      }
    };
    fetchChartData();

  }, []);

  function cleanUrl(url) {
    const botRequestParam = "?botrequest=true";
    if (url.includes(botRequestParam)) {
      return url.replace(botRequestParam, "");
    }
    return url;
  }

  function aggregateArray(initialArray) {
    const excludedSections = [
      "kaupallinen yhteistyo ilkka-pohjalainen",
      "kaupallinen yhteistyo epari",
      "kaupallinen yhteistyo vaasa",
      "ilkan arkisto ilkka-pohjalainen",
      "pohjalaisen arkisto ilkka-pohjalainen",
      "no section",
      "komiat",
      "viiskunta",
      "jarviseutu",
      "jurvan-sanomat",
      "suupohjan-sanomat"
    ];
    const filteredArray = initialArray.filter((item) => !excludedSections.some(excludedSection => item.section.includes(excludedSection)));
    const urlMap = new Map();
    filteredArray.forEach((item) => {
      const cleanedUrl = cleanUrl(item.url);
      const { access = null, date = null, url, section = null, count = 0, title = "", last_published_at = null, headline = "" } = item;
      const countInt = parseInt(count, 10);
      if (urlMap.has(cleanedUrl)) {
        const existing = urlMap.get(cleanedUrl);
        existing.count += countInt;
        if (access) existing.access = access;
        if (title) existing.title = title;
        if (headline) existing.headline = headline;
        if (section) existing.section = section;
        if (date) existing.date = date;
        if (last_published_at) existing.last_published_at = last_published_at;
      } else {
        urlMap.set(cleanedUrl, {
          access,
          date,
          url: cleanedUrl,
          section,
          count: countInt,
          title,
          last_published_at,
          headline,
        });
      }
    });
    return Array.from(urlMap.values()).sort((a, b) => b.count - a.count);
  }
  const uniqueStories = aggregateArray(Object.values(chartbeatStories || []));
  let uniqueStoriesSliced = uniqueStories;
  if (uniqueStories && uniqueStories.length > 20) {
    uniqueStoriesSliced = uniqueStories.slice(0, 20);
  }

  const handleLoadMore = () => setLoadMore(loadMore + 5);
  let paperName = "";
  function getPaperName(section) {
    if (section.includes(" epari")) {
      paperName = `Epari |`;
      return paperName;
    } else if (section.includes(" vaasa")) {
      paperName = `Vaasa-lehti |`;
      return paperName;
    }
    paperName = "";
    return null;
  }
  function checkHeadline(title, headline) {
    const parts = (title && title.split(" | ")) || [];
    if (parts.length > 1 && parts[1] === "Ilkka-Pohjalainen") {
      return headline ? headline : parts[0];
    }
    return headline || parts[0];
  }

  return (
    (uniqueStories && uniqueStoriesSliced.length > 19) && <React.Fragment>
      <div styleName="sidebar-global">
        <h2 className="top-headline top-headline-suosituimmat" styleName="top-headline">
          Luetuimmat
        </h2>
        <div>
          {uniqueStoriesSliced.slice(0, loadMore).map((story, index) => {
            let accessType = story.access || null;
            if (currentUrlSlug === "vaasalehti" || currentUrlSlug === "epari") {
              accessType = "public";
            }
            return (
              <div styleName="item-wrapper" key={index}>
                <span>{index + 1} </span>
                <div key={story.url} styleName="wrapper" className="wrapper-newest-category">
                  <h2 styleName="headline">
                    <Link className="main-headline" href={story.url}>
                      {checkHeadline(story.title, story.headline)}
                    </Link>
                  </h2>
                  <div styleName="section-time-wrapper" className="section-time-wrapper">
                    <div>
                      {story["last_published_at"] ? (
                        <TimeStamp timeStamp={story["last_published_at"]} prefix={getPaperName(story.section)} />
                      ) : (
                        <TimeStamp timeStamp={story.date} prefix={getPaperName(story.section)} />
                      )}
                    </div>
                    <div>{!getPaperName(story.section) && <StarShowHide accessType={accessType} />}</div>
                  </div>
                </div>
              </div>
            );
          })}
          {uniqueStoriesSliced.length > loadMore && <ShowMoreBtn loadMore={handleLoadMore} btnName="NÄYTÄ LISÄÄ" />}
        </div>
      </div>
    </React.Fragment>
  );
};

export default ChartbeatStories;
